import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import classNames from "classnames";
import Link from "../../../../elements/Link";

var ListOfLinksGroup = function ListOfLinksGroup(_ref) {
  var children = _ref.children,
      href = _ref.href,
      title = _ref.title;
  var getClassName = getClassNameFactory(ListOfLinksGroup.displayName);
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      modifiers: classNames({
        noParentLink: !href
      })
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "parent"
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: href
  }, title)), /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children));
};

ListOfLinksGroup.displayName = "ListOfLinks.Group";
ListOfLinksGroup.propTypes = {
  /**
   * ListOfLinks Links to render.
   */
  children: PropTypes.node.isRequired,

  /**
   * Optional URL for the parent link.
   */
  href: PropTypes.string,

  /**
   * Title for the parent link.
   */
  title: PropTypes.string.isRequired
};
export default ListOfLinksGroup;